module.exports = __webpack_public_path__ + "assets/135572198601767ada60b50b431c1f72.png";